import React, { useEffect } from 'react';
import CanvasJSReact from "@canvasjs/react-charts";

const DoughnutChart = ({ allDatas }) => {
    useEffect(() => {
        const chart = new CanvasJSReact.CanvasJS.Chart("chartContainer", {
            animationEnabled: true,
            subtitles: [
                {
                    text: "Total quizzes",
                    verticalAlign: "center",
                    fontSize: 16,
                    fontWeight: 600,
                    fontFamily: "Montserrat",
                    fontColor: "#62636C",
                    // lineHeight: 25,
                },
                {
                    text: `${allDatas?.total_quizes}`,
                    verticalAlign: "center",
                    fontSize: 20,
                    fontWeight: 100,
                    fontColor: "#62636C",
                    lineHeight: 25,
                    dockInsidePlotArea: true,
                    padding: {
                        top: 50
                    }
                }
            ],

            data: [
                {
                    type: "doughnut",
                    dataPoints: [
                        { y: allDatas?.completed_quizzes, color: "#576FA8", },
                        { y: allDatas?.in_progress_quizzes, color: "#B9BBC6" },
                        { y: (allDatas?.over_90 ?? 0).toFixed(0), color: "#D9C872" }
                    ],
                },
            ],
        });

        chart.render();
    }, [allDatas]);

    return (
        <div id="chartContainer" style={{ height: 250, width: "100%" }}></div>
    );
};

export default DoughnutChart;